<template>
  <div
    class="modal beta-site-modal"
    :class="{ 'is-active': modelValue }"
    role="dialog"
    aria-modal="true"
    aria-labelledby="beta-site-title"
    aria-describedby="beta-site-description"
    @keydown.esc="stay"
  >
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p
          id="beta-site-title"
          class="modal-card-title"
        >
          <span class="icon">
            <i class="fas fa-rocket" />
          </span>
          {{ $t('betaSite.title') }}
        </p>
      </header>

      <section class="modal-card-body">
        <p
          id="beta-site-description"
          class="beta-site-description"
        >
          {{ $t('betaSite.description') }}
        </p>
      </section>

      <footer class="modal-card-foot">
        <button
          type="button"
          class="button is-light"
          data-test="beta-site-stay"
          @click="stay"
        >
          {{ $t('betaSite.stay') }}
        </button>
        <button
          ref="goButton"
          type="button"
          class="button is-primary"
          data-test="beta-site-go"
          @click="go"
        >
          {{ $t('betaSite.go') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';
import { goToBetaSite } from '@/utils/betaSite';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const goButton = ref(null);

watch(
  () => props.modelValue,
  async (isOpen) => {
    if (!isOpen) {
      return;
    }

    await nextTick();
    goButton.value?.focus();
  },
);

const stay = () => {
  emit('update:modelValue', false);
};

const go = () => {
  goToBetaSite();
};
</script>

<style scoped>
.beta-site-description {
  margin: 0;
  line-height: 1.5;
}

.beta-site-modal :deep(.modal-card-foot) {
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .beta-site-modal :deep(.modal-card-foot) {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .beta-site-modal :deep(.modal-card-foot .button) {
    width: 100%;
  }
}
</style>
